import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store'

Vue.use(VueRouter)

const isAuth = (from, to, next) => {
  // get Vue prototype directus
  next()
  let token = localStorage.getItem('token') || ''
  Vue.prototype.$directus.auth.static(token).then(() => {
    Vue.prototype.$directus.users.me.read({
      fields: ['*.*'],
    }).then((response) => {
      store.dispatch('setUser', response)
    }).catch((err)=>{
      next(`/login?err=${err.message}`)
    });
  }).catch((error) => {
    console.log(error)
    next('/login')
  })
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    beforeEnter: isAuth
  },
  {
    path: '/members',
    name: 'members',
    component: () => import(/* webpackChunkName: "members" */ '../views/MembersView.vue'),
    beforeEnter: isAuth
  },
  {
    path:'/login',
    name:'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
